import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.small.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useRef, useEffect } from 'react';
import Chart from 'chart.js/auto';
import { useTheme } from 'styled-components';
import useBreakpoints from 'hooks/useBreakpoints';
import { getColorBlock } from 'utils/ui/colors';
import { remToPx } from 'utils/ui';
import { jsx as _jsx } from "react/jsx-runtime";
function BarChart(_ref) {
  var data = _ref.data,
    label = _ref.label,
    ariaLabel = _ref.ariaLabel,
    labels = _ref.labels,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'chart' : _ref$color,
    nullLabel = _ref.nullLabel,
    _ref$showLegend = _ref.showLegend,
    showLegend = _ref$showLegend === void 0 ? false : _ref$showLegend,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? false : _ref$animation,
    onXLabelClick = _ref.onXLabelClick,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 100 : _ref$max,
    _ref$decimalPlaces = _ref.decimalPlaces,
    decimalPlaces = _ref$decimalPlaces === void 0 ? 0 : _ref$decimalPlaces,
    getValueLabel = _ref.getValueLabel,
    _ref$hideValue = _ref.hideValue,
    hideValue = _ref$hideValue === void 0 ? false : _ref$hideValue,
    yTicks = _ref.yTicks,
    getYTickLabel = _ref.getYTickLabel;
  var canvasRef = useRef(null);
  var chartRef = useRef(null);
  var _useBreakpoints = useBreakpoints(),
    isDesktop = _useBreakpoints.s;
  var theme = useTheme();
  var chartColor = getColorBlock(color, theme);
  var textColor = theme.text;
  var linkColor = theme.links;
  // The tooltip always shows the full "X out of N" context; the axis
  // only repeats a suffix when it's a genuine unit ("%")
  var tooltipSuffix = max === 100 ? '%' : "/".concat(max);
  var axisSuffix = max === 100 ? '%' : '';
  var isEmpty = data.length === 0 || labels.length === 0;
  useEffect(function () {
    var canvas = canvasRef.current;
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    var chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [{
          label: label,
          data: data,
          backgroundColor: chartColor,
          borderRadius: theme.globals.borderRadius.small,
          barPercentage: 0.7,
          categoryPercentage: 0.9
        }]
      },
      options: {
        animation: animation,
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            beginAtZero: true,
            grid: {
              display: false
            },
            ticks: {
              autoSkip: false,
              color: onXLabelClick ? linkColor : textColor,
              font: {
                family: 'Open Sans'
              }
            },
            border: {
              color: chartColor
            }
          },
          y: _objectSpread(_objectSpread({
            min: 0,
            max: max
          }, yTicks && {
            afterBuildTicks: function afterBuildTicks(scale) {
              scale.ticks = yTicks.map(function (value) {
                return {
                  value: value
                };
              });
            }
          }), {}, {
            ticks: {
              stepSize: max / 5,
              // Forces 5 evenly spaced steps
              autoSkip: false,
              callback: function callback(val) {
                return getYTickLabel ? getYTickLabel(Number(val)) : "".concat(val).concat(axisSuffix);
              },
              color: textColor,
              font: {
                family: 'Open Sans'
              }
            },
            border: {
              color: chartColor
            },
            grid: {
              display: true
            }
          })
        },
        // This is used to ensure that tooltips are displayed even if the data value is null
        interaction: {
          mode: 'index',
          intersect: false
        },
        plugins: {
          legend: {
            display: showLegend
          },
          tooltip: {
            displayColors: false,
            titleColor: theme.background,
            titleFont: {
              weight: 'bold',
              size: remToPx(theme.globals.typeScale.s),
              family: 'Open Sans'
            },
            bodyColor: theme.background,
            bodyFont: {
              size: remToPx(theme.globals.typeScale.s),
              family: 'Open Sans'
            },
            backgroundColor: theme.text,
            borderWidth: 0,
            cornerRadius: theme.globals.borderRadius.small,
            callbacks: {
              label: function label(tooltipItem) {
                var _decimalPlaces$toolti;
                if (tooltipItem.raw === null) {
                  return nullLabel;
                }
                var barDecimalPlaces = Array.isArray(decimalPlaces) ? (_decimalPlaces$toolti = decimalPlaces[tooltipItem.dataIndex]) !== null && _decimalPlaces$toolti !== void 0 ? _decimalPlaces$toolti : 0 : decimalPlaces;
                var value = Number(tooltipItem.raw);
                var formattedValue = "".concat(value.toFixed(barDecimalPlaces)).concat(tooltipSuffix);
                var valueLabel = getValueLabel === null || getValueLabel === void 0 ? void 0 : getValueLabel(value);
                if (hideValue) {
                  return valueLabel !== null && valueLabel !== void 0 ? valueLabel : nullLabel;
                }
                return valueLabel ? "".concat(formattedValue, " \xB7 ").concat(valueLabel) : formattedValue;
              }
            }
          }
        }
      }
    });
    chartRef.current = chart;
    var handleClick = function handleClick(event) {
      if (!chart || !onXLabelClick) return;
      var xScale = chart.scales.x;
      var clickX = event.offsetX;
      var pixelMargin = 30;
      xScale.ticks.forEach(function (tick, i) {
        var pixel = xScale.getPixelForTick(i);
        if (Math.abs(pixel - clickX) < pixelMargin) {
          var labelAtIndex = labels[i];
          if (labelAtIndex) {
            onXLabelClick(labelAtIndex);
          }
        }
      });
    };
    var handleMouseMove = function handleMouseMove(event) {
      if (!chart || !onXLabelClick) return;
      var xScale = chart.scales.x;
      var hoverX = event.offsetX;
      var pixelMargin = 30;
      var hovering = false;
      xScale.ticks.forEach(function (tick, i) {
        var pixel = xScale.getPixelForTick(i);
        if (Math.abs(pixel - hoverX) < pixelMargin) {
          hovering = true;
        }
      });
      canvas.style.cursor = hovering ? 'pointer' : 'default';
    };
    canvas.addEventListener('click', handleClick);
    canvas.addEventListener('mousemove', handleMouseMove);
    return function () {
      chart.destroy();
      canvas.removeEventListener('click', handleClick);
      canvas.removeEventListener('mousemove', handleMouseMove);
    };
  }, [data, labels, color, isDesktop, isEmpty, theme, animation, nullLabel, ariaLabel, label, showLegend, chartColor, textColor, onXLabelClick, linkColor, max, tooltipSuffix, axisSuffix, decimalPlaces, getValueLabel, hideValue, yTicks, getYTickLabel]);
  return /*#__PURE__*/_jsx("canvas", {
    ref: canvasRef,
    role: "img",
    "aria-label": ariaLabel
  });
}
export default BarChart;